import { withRouter } from 'react-router-dom'
import * as H from 'history'
import ProtocolVersions from './protocol_versions'

type Props = {
    history: H.History
}

const ProtocolVersionsPage = (props: Props) => {
    return (
        <>
            <ProtocolVersions history={props.history} />
        </>
    )
}

export default withRouter(ProtocolVersionsPage)
